import { AfterViewInit, Component, OnInit, TemplateRef, ViewChild, ViewContainerRef } from "@angular/core";
import { DatePipe } from "@angular/common";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { ISubscription } from "rxjs/Subscription";

import { GridDataResult } from "@progress/kendo-angular-grid";

import { ActionName } from "@shared/enums/action-name";
import { AuthService } from "src/app/services/auth.service";
import { CommonMethods } from "src/app/services/common.method";
import { CommonService } from "@shared/services/common";
import { Constants } from "@shared/models/constants";
import { DataSharingLTE } from "@fs/services/data-sharing-lte";
import { PrintService } from "src/app/services/print-layout.service";
import { TabOpenService } from "src/app/services/tab-open.service";
import { Tabs } from "src/app/enums/tab.enum";
import { TimeZoneConverter } from "@shared/pipes/timezone-converter";
import { WorkOrderService } from "@fs/services/work-order";
import { NotificationsService } from "@shared/services/notification";
import { WorkTicketPaymentSummary } from "src/app/fs-lte/models/work-order/work-order.model";
import { PermissionPipe } from "@shared/pipes/permission";
import { WOSChangeEventDestination } from "@fs/enums/common";
import { CodeTypes } from "src/app/fs-lte/enums/code-types.enum";
import { DispatcherService } from "@fs/services/dispatcher";
import { SpinnerService } from "src/app/shared/services/spinner.service";
import { WoBaseComponent } from "@fs/components/base/wo-base.component";
import { FsUtil } from "@fs/services/fs-utils";
import { TabParams } from "@fs/services/tab-params.service";
import { TemplateModel } from "@fs/models/template.model";

@Component({
  selector: "app-work-order-detail",
  templateUrl: "./wo-detail.component.html",
  styleUrls: ["./wo-detail.component.scss"],
  providers: [TimeZoneConverter, DatePipe]
})
export class WorkOrderDetailComponent extends WoBaseComponent implements OnInit, AfterViewInit {
  @ViewChild('tab4') tab4Ref: TemplateRef<any>;
  // #region  Private variables
  private fromStatus: string = "";
  private fromSubStatus: string = "";
  private initialData: any;
  private inputParams: any;
  private tabCounter: number;
  public BalanceOwed = 0;
  public DiscountAmount = 0;
  public EditDisabled: boolean = false;
  public StatusList = [];
  public TotalAmount = 0;
  private subscriptions: ISubscription[] = [];
  // #endregion

  // #region  Public Variables
  public isEquipmentLinkOpened: boolean = false;
  public EquipmentDialogueData: { Description: string, WorkTicketPriceBookItemEquipments: any[], location: { x: number, y: number } } = { Description: '', WorkTicketPriceBookItemEquipments: null, location: { x: -10000, y: -10000 } };
  public equipmentLinksPath: string = Constants.DefaultImagePaths.WorkOrderEquipmentLink;
  public ActionName = ActionName;
  public Details: any;
  public approvedPBItems: GridDataResult;
  public cancelReasonPopup: boolean = false;
  public cancelationFormGroup: FormGroup;
  public confirmActionCancelBtn: string = "";
  public confirmActionOkBtn: string = "";
  public confirmMessage: string = "";
  public confirmationBox: boolean = false;
  public defaultLaborImage: string = Constants.DefaultImagePaths.Labour;
  public defaultMaterialImage: string = Constants.DefaultImagePaths.Material;
  public defaultServiceImage: string = Constants.DefaultImagePaths.Service;
  public isError: boolean = false;
  public priceBookItems: GridDataResult;
  public primaryCustomerContact: any;
  public primaryJobSiteContact: any;
  public primaryTechnician: any;
  public totalPaidDetails: GridDataResult;
  public voidFormGroup: FormGroup;
  public voidTicketPopup: boolean = false;
  public workTicketCancelReasonLookup: any;
  public workTicketVoidReasonLookup: any;
  public workTicketPayment: WorkTicketPaymentSummary;
  public showAttachmentSlider: boolean = false;
  public slideIndex: number = 0;
  public attachments: GridDataResult = { data: [], total: 0 };
  public primaryTech: any;
  public helpers = [];
  public hasEditWorkOrderPermission: boolean = false;
  public showdropdownLoder: boolean = false;
  public companyData: any;
  public customerAddress: string;
  public jobSiteAddress: string;
  public agreementDiscount = 0;
  public estimatesConvertedTo: any;
  // #endregion

  // #region  LifeCycle Events
  constructor(
    private auth: AuthService,
    private commonMethods: CommonMethods,
    private dataSharing: DataSharingLTE,
    private datePipe: DatePipe,
    private httpCommon: CommonService,
    private httpService: WorkOrderService,
    private printService: PrintService,
    private tabOpen: TabOpenService,
    private toastr: NotificationsService,
    private permissionPipe: PermissionPipe,
    private showspinner: SpinnerService,
    private viewContainerRef: ViewContainerRef,
    private helperService: DispatcherService
  ) {
    super();
   }
  ngOnInit() {
    this.initSubTabs();
    this.InitializeForm();
  }
  ngOnDestroy() {
    this.subscriptions.forEach(element => {
      element.unsubscribe();
    });
  }
  ngAfterViewInit() {
    $(".main__content_section").scrollTop(0);
  }
  viewEstimate(val) {
    let params = Object.assign({},val);
    params["Customer"] = { ID: params["CustomerID"] };
    params["JobSiteID"]= params.JobSite.ID;
    this.tabOpen.OpenTab({
      tabId: Tabs.EstimateDetail,
      params: params,
      tabTitle: val.EstimateNo == null ? " " : val.EstimateNo,
      replaceIfOpen: {
            replaceTab: true,
            tabToReplace: Tabs.EstimateEdit,
            action: "focus"
      }
    });
  }
  editEstimate(val) {
    let params = Object.assign({},val);
    params["Customer"] = { ID: params["CustomerID"] };
    this.tabOpen.OpenTab({
      tabId: Tabs.EstimateEdit,
      params: params,
      tabTitle: val.EstimateNo == null ? " " : val.EstimateNo,
      replaceIfOpen: {
            replaceTab: true,
            tabToReplace: Tabs.EstimateDetail,
            action: "replace"
      }
    });
  }
  viewPBEstimate(val,customerID?: string) {
    let params = Object.assign({},val);
    params["Customer"] = { ID: customerID};
    params["JobSiteID"]= params.JobSite.ID;
    this.tabOpen.OpenTab({
      tabId: Tabs.EstimateDetail,
      params: params,
      tabTitle: val.EstimateNo == null ? " " : val.EstimateNo,
      replaceIfOpen: {
            replaceTab: true,
            tabToReplace: Tabs.EstimateEdit,
            action: "focus"
      }
    });
  }
  // #endregion

  // #region  Private Methods
  private InitializeForm(instantSpinnerTime: number = Constants.defaultSpinnertimeout) {
    let subscription = this.dataSharing.OrderStatusChangeEvent.subscribe(
      response => {
        this.Details.Status = response.Status;
        this.Details.SubStatus = response.SubStatus;
      }
    );
    this.subscriptions.push(subscription);
    this.showdropdownLoder = true;
    subscription = this.httpCommon
      .GetIntialData(
        this.auth.getCompanyId(),
        "WorkTicketCancelReasonLookup,WorkTicketVoidReasonLookup,CodeTypeData,equipmentwarrantytype, equipmentmanufacturers, equipmentcategories"
      )
      .subscribe(response => {
        this.showdropdownLoder = false;
        this.initialData = response;
        this.companyData = response;
        this.workTicketCancelReasonLookup = this.initialData.WorkTicketCancelReasonLookup.filter(
          x => x.IsActive == true
        );
        this.workTicketVoidReasonLookup = this.initialData.WorkTicketVoidReasonLookup.filter(
          x => x.IsActive
        );
      }, error => {
        this.showdropdownLoder = false;
      });
    this.subscriptions.push(subscription);
    this.GetWorkOrderDetail(instantSpinnerTime);
    this.hasEditWorkOrderPermission = this.permissionPipe.transform(ActionName.EditWorkOrder);
  }
  private IntializeCancelationFrom() {
    this.cancelationFormGroup = new FormGroup({
      CancellationReason: new FormControl("", [Validators.required]),
      CancellationComment: new FormControl("", [
        this.commonMethods.noWhitespaceValidator
      ])
    });
  }
  private IntializeVoidFrom() {
    this.voidFormGroup = new FormGroup({
      VoidReason: new FormControl("", [Validators.required]),
      VoidComment: new FormControl("", [
        this.commonMethods.noWhitespaceValidator
      ])
    });
  }
  private GetDiscountedAndTaxedAmount() {
    if (this.Details.WorkTicketPayment == null) {
      this.workTicketPayment.TotalAmount = 0;
      this.workTicketPayment.BalanceOwed = 0;
      this.workTicketPayment.DiscountAmount = 0;
      this.workTicketPayment.TaxedAmount = 0;
      this.workTicketPayment.TotalApproved = 0;
      return;
    }
    this.workTicketPayment.TotalPaid = this.Details.WorkTicketPayment.TotalPaid;
    this.workTicketPayment.TaxedAmount = this.Details.WorkTicketPayment.TaxedAmount;
    this.workTicketPayment.NetTaxable = this.Details.WorkTicketPayment.NetTaxable;
    //this.DiscountAmount = 
    this.workTicketPayment.DiscountAmount = this.Details.WorkTicketPayment.TotalDiscount;
    this.workTicketPayment.TotalApproved = this.Details.WorkTicketPayment.TotalApprovedPrice;
    //this.TotalAmount =
    this.workTicketPayment.TotalAmount = this.workTicketPayment.TotalApproved
      + this.workTicketPayment.TaxedAmount - this.workTicketPayment.DiscountAmount;
    //this.BalanceOwed =
    this.workTicketPayment.BalanceOwed = this.workTicketPayment.TotalAmount - this.workTicketPayment.TotalPaid;
  }
  private GetWorkOrderDetail(instantSpinnerTime: number = Constants.defaultSpinnertimeout) {
    this.showspinner.showloader(this.viewContainerRef, this.tabCounter,instantSpinnerTime);
    if (!FsUtil.checkNullOrUndefined([this.inputParams["activeSubTabIndex"]]))
      FsUtil.selectTabStrip(this.subTabs, this.inputParams["activeSubTabIndex"]);
      
    let subscription = this.httpService.GetWorkOrder(this.inputParams).subscribe(response => {
      this.Details = response;
      if (this.subTabs.length !== 4 && this.Details.EstimatesOriginatedFrom.length > 0) {
        this.subTabs.push(new TemplateModel(3, 'Estimates', this.tab4Ref, false));
      }
      if (!CommonMethods.CheckNullOrUndefined(this.Details)) {
        this.customerAddress = CommonMethods.GetCompleteAddress(this.Details.Customer);
        this.jobSiteAddress = CommonMethods.GetCompleteAddress(this.Details.JobSite)
      }
      this.fromSubStatus = this.Details.SubStatus.Code.toLocaleLowerCase();
      this.fromStatus = this.Details.Status.Code.toLocaleLowerCase();

      if (!CommonMethods.CheckNullOrUndefined(this.Details.JobSite.Contacts, true)) {
        this.primaryJobSiteContact = this.Details.JobSite.Contacts.find(x => x.Contact.IsPrimary == true);
        if (CommonMethods.CheckNullOrUndefined(this.primaryJobSiteContact.Contact.LastName))
          this.primaryJobSiteContact.Contact.LastName = "";
      } else {
        this.primaryJobSiteContact = null;
      }
      if (!CommonMethods.CheckNullOrUndefined(this.Details.Customer.Contacts, true)) {
        this.primaryCustomerContact = this.Details.Customer.Contacts.find(x => x.Contact.IsPrimary == true);
        if (CommonMethods.CheckNullOrUndefined(this.primaryCustomerContact.Contact.LastName))
          this.primaryCustomerContact.Contact.LastName = "";
      } else {
        this.primaryCustomerContact = null;
      }
      if (!CommonMethods.CheckNullOrUndefined(this.Details)) {
        this.estimatesConvertedTo = this.Details.EstimatesConvertedTo.find(
        x => x.IsUsedToCreateWorkTicket == true
      );
      }

      // Primary Tech
      let appointmentTypes = this.commonMethods.getCodeTypeData(CodeTypes.AppointmentType);
      let technicianCodeTypeId = appointmentTypes.find(x => x.Code == 'PrimaryTech').ID;

      this.primaryTech = this.Details.UserAppointments.find(x => x.AppointmentTypeID == technicianCodeTypeId);
      if (!CommonMethods.CheckNullOrUndefined(this.primaryTech)) {
        let promisedDt = this.datePipe.transform(this.primaryTech.AppointmentDate, "MM/dd/yyyy");
        let startTime = "00:00:00";
        if (this.primaryTech.StartTime != null) {
          startTime = this.primaryTech.StartTime;
          this.primaryTech.StartTime = this.datePipe.transform(new Date(promisedDt + " " + this.primaryTech.StartTime), "hh:mm a");
          if (this.primaryTech.EndTime != null) {
            let startTimeDt = new Date(promisedDt + " " + this.primaryTech.StartTime);
            let endTimeDt = new Date(promisedDt + " " + this.primaryTech.EndTime);
            let timeDiff = endTimeDt.getTime() - startTimeDt.getTime();
            let min = Math.floor((timeDiff % 3600000) / 60000);
            this.primaryTech.EndTime = Math.floor(timeDiff / 3600000) + "h : ";
            this.primaryTech.EndTime += (min == 0) ? "00 m" : min + "m";
          }
        }
        this.primaryTech.AppointmentDate = new Date(promisedDt + " " + startTime);
      } else {
        let durationArray = ['0', '00', '00'];
        if (!CommonMethods.CheckNullOrUndefined(this.Details.Duration))
          durationArray = this.Details.Duration.split(':');

        let endtime = durationArray[0] + "h : ";
        endtime += (durationArray[1].toString() == '00' || durationArray[1].toString() == '0') ? "00 m" : durationArray[1] + "m";
        this.primaryTech = Object.assign({}, {
          User: null,
          StartTime: null,
          EndTime: endtime,
          AppointmentDate: new Date(this.Details.PromisedDate)
        });
      }

      //Helpers
      let helperCodeTypeId = appointmentTypes.find(x => x.Code == 'Helper').ID;
      this.helpers = this.Details.UserAppointments.filter(x => x.AppointmentTypeID == helperCodeTypeId);
      this.helpers.forEach(element => {
        let appointmentDate = this.datePipe.transform(element.AppointmentDate, "MM/dd/yyyy");
        let startTime = "00:00:00";
        if (element.StartTime != null) {
          startTime = element.StartTime;
          element.EndTimeObject = element.EndTime;
          element.StartTimeObject = element.StartTime;
          element.StartTime = this.datePipe.transform(new Date(appointmentDate + " " + element.StartTime), "hh:mm a");
          if (element.EndTime != null) {
            let startTimeDt = new Date(appointmentDate + " " + element.StartTime);
            let endTimeDt = new Date(appointmentDate + " " + element.EndTime);
            let timeDiff = endTimeDt.getTime() - startTimeDt.getTime();
            let min = Math.floor((timeDiff % 3600000) / 60000);
            element.EndTime = Math.floor(timeDiff / 3600000) + "h : ";
            element.EndTime += (min == 0) ? "00 m" : min + "m";
          }
        }
        element.AppointmentDate = new Date(appointmentDate + " " + startTime);


        element.Priority = this.Details.Priority;
        element.PromisedTime = this.Details.PromisedTime;
        element.Status = this.commonMethods.GetHelperStatus(element.StatusID, element.SubStatusID);
        element.IsDispatchingAllowed = (element.Status.Code == 'assigned') ? true : false;
        element.IsUndoDispatchingAllowed = (element.Status.Code == 'dispatched') ? true : false;
      });
  
      let totalAgreementPrice = 0;
      let totalStandardPrice = 0;
      if (
        this.Details.WorkTicketPriceBookItems != null &&
        this.Details.WorkTicketPriceBookItems != undefined
      ) {
        this.Details.WorkTicketPriceBookItems.forEach(x => {
          if (x.AgreementPrice != null && x.Price == x.OriginalPrice) {
            x.Price = x.AgreementPrice;
            totalAgreementPrice += (x.Quantity * x.AgreementPrice);     
            totalStandardPrice += (x.Quantity * x.OriginalPrice);
          }
          x.PriceBookItem.ImagePath = this.commonMethods.GetProductDefaultImg(x.PriceBookItem);
        });
      }
      if (this.Details.WorkTicketAttachments != null) {
        this.GetWorkOrderDocumentsAndImages(this.Details.WorkTicketAttachments);
      }
      this.agreementDiscount = totalStandardPrice - totalAgreementPrice;
      this.workTicketPayment = new WorkTicketPaymentSummary();
      this.GetDiscountedAndTaxedAmount();
      this.GetStatusList();
      this.GetTotalPaidDetails();
      this.GetPBItems();
      this.GetAPBItems();
      this.showspinner.hideLoader(this.viewContainerRef, this.tabCounter);
    },
      error => {
        this.showspinner.hideLoader(this.viewContainerRef, this.tabCounter);
        if (!CommonMethods.CheckNullOrUndefined(error.error))
          this.toastr.showMultiLineError(error.error.Message, "Error");
      }
    );
    this.subscriptions.push(subscription);
  }
  private GetPBItems() {
    if (this.Details != null)
      this.priceBookItems = {
        data: this.Details.WorkTicketPriceBookItems,
        total: this.Details.WorkTicketPriceBookItems.length
      };
    else this.priceBookItems = { data: [], total: 0 };
  }
  private GetTotalPaidDetails() {
    if (CommonMethods.CheckNullOrUndefined(this.Details) || CommonMethods.CheckNullOrUndefined(this.Details.WorkTicketPayment)
      || CommonMethods.CheckNullOrUndefined(this.Details.WorkTicketPayment.WorkTicketPaidDetails)) {
      this.totalPaidDetails = { data: [], total: 0 };
    } else {
      this.totalPaidDetails = {
        data: this.Details.WorkTicketPayment.WorkTicketPaidDetails,
        total: this.Details.WorkTicketPayment.WorkTicketPaidDetails.length
      };
    }
  }
  private ChangeStatusApi() {
    let data = {
      ID: this.Details.ID,
      CancellationComment: "",
      WorkTicketStatusAction: "",
      CancellationReason: null,
      VoidComment: "",
      VoidReason: null,
      JobSite: { ID: this.Details.JobSite.ID },
      Customer: { ID: this.Details.Customer.ID },
      Status: {},
      SubStatus: {},
      CancellationReasonId: CommonMethods.GetID(),
      VoidReasonId: CommonMethods.GetID()
    };
    let StatusID = "";
    let SubStatusID = "";
    let toStatus = "";
    this.showspinner.showloader(this.viewContainerRef, this.tabCounter);
    if (this.confirmActionOkBtn == Constants.WOStaticStatus().completeWithWarning) {
      StatusID = this.initialData.CodeTypeData.WorkTicketStatus.find(x => x.Code.toLowerCase() == Constants.WOStaticStatus().completed).ID;
      SubStatusID = this.initialData.CodeTypeData.WorkTicketSubStatus.find(x => x.Code.toLowerCase() == Constants.WOStaticStatus().readyforreview).ID;
      toStatus = Constants.WOStaticStatus().completed;
      data.WorkTicketStatusAction = Constants.WOStaticStatus().Complete;
      data.Status = { ID: StatusID };
      data.SubStatus = { ID: SubStatusID };
    } else if (this.confirmActionOkBtn == Constants.WOStaticStatus().CancelWorkOrder) {
      StatusID = this.initialData.CodeTypeData.WorkTicketStatus.find(x => x.Code.toLowerCase() == Constants.WOStaticStatus().cancelled).ID;
      SubStatusID = this.Details.SubStatus.ID;
      toStatus = Constants.WOStaticStatus().cancelled;
      data.WorkTicketStatusAction = Constants.WOStaticStatus().Cancel;
      data.Status = { ID: StatusID };
      data.SubStatus = { ID: SubStatusID };
      data.CancellationReason = {
        ID: this.cancelationFormGroup.controls["CancellationReason"].value
      };
      data.CancellationReasonId = this.cancelationFormGroup.controls["CancellationReason"].value;
      data.CancellationComment = this.cancelationFormGroup.controls["CancellationComment"].value;
    } else if (this.confirmActionOkBtn == Constants.WOStaticStatus().VoidWorkOrder) {
      StatusID = this.initialData.CodeTypeData.WorkTicketStatus.find(x => x.Code.toLowerCase() == Constants.WOStaticStatus().void).ID;
      SubStatusID = this.Details.SubStatus.ID;
      toStatus = Constants.WOStaticStatus().void;
      data.WorkTicketStatusAction = Constants.WOStaticStatus().Void;
      data.Status = { ID: StatusID };
      data.SubStatus = { ID: SubStatusID };
      data.VoidReason = { ID: this.voidFormGroup.controls["VoidReason"].value };
      data.VoidReasonId = this.voidFormGroup.controls["VoidReason"].value;
      data.VoidComment = this.voidFormGroup.controls["VoidComment"].value;
    } else if (this.confirmActionOkBtn == Constants.WOStaticStatus().DispatchWorkOrder) {
      StatusID = this.initialData.CodeTypeData.WorkTicketStatus.find(x => x.Code.toLowerCase() == Constants.WOStaticStatus().open).ID;
      SubStatusID = this.initialData.CodeTypeData.WorkTicketSubStatus.find(x => x.Code.toLowerCase() == Constants.WOStaticStatus().dispatched).ID;
      toStatus = Constants.WOStaticStatus().dispatched;
      data.WorkTicketStatusAction = Constants.WOStaticStatus().Dispatch;
      data.Status = { ID: StatusID };
      data.SubStatus = { ID: SubStatusID };
    } else if (this.confirmActionOkBtn == Constants.WOStaticStatus().RescheduleWorkOrder) {
      StatusID = this.initialData.CodeTypeData.WorkTicketStatus.find(x => x.Code.toLowerCase() == Constants.WOStaticStatus().actionrequired).ID;
      SubStatusID = this.initialData.CodeTypeData.WorkTicketSubStatus.find(x => x.Code.toLowerCase() == Constants.WOStaticStatus().rescheduled).ID;
      toStatus = Constants.WOStaticStatus().rescheduled;
      data.WorkTicketStatusAction = Constants.WOStaticStatus().Reschedule;
      data.Status = { ID: StatusID };
      data.SubStatus = { ID: SubStatusID };
    } else if (this.confirmActionOkBtn == Constants.WOStaticStatus().RemoveTechnician) {
      StatusID = this.initialData.CodeTypeData.WorkTicketStatus.find(x => x.Code.toLowerCase() == Constants.WOStaticStatus().open).ID;
      SubStatusID = this.initialData.CodeTypeData.WorkTicketSubStatus.find(x => x.Code.toLowerCase() == Constants.WOStaticStatus().unassigned).ID;
      toStatus = Constants.WOStaticStatus().unassigned;
      data.WorkTicketStatusAction = Constants.WOStaticStatus().Unassign;
      data.Status = { ID: StatusID };
      data.SubStatus = { ID: SubStatusID };
    } else if (this.confirmActionOkBtn == Constants.WOStaticStatus().SameTechnician) {
      StatusID = this.initialData.CodeTypeData.WorkTicketStatus.find(x => x.Code.toLowerCase() == Constants.WOStaticStatus().open).ID;
      SubStatusID = this.initialData.CodeTypeData.WorkTicketSubStatus.find(x => x.Code.toLowerCase() == Constants.WOStaticStatus().assigned).ID;
      toStatus = Constants.WOStaticStatus().assigned;
      data.WorkTicketStatusAction = Constants.WOStaticStatus().Assign;
      data.Status = { ID: StatusID };
      data.SubStatus = { ID: SubStatusID };
    } else if (this.confirmActionOkBtn == Constants.WOStaticStatus().ContinuewithWorkOrder) {
      StatusID = this.initialData.CodeTypeData.WorkTicketStatus.find(x => x.Code.toLowerCase() == Constants.WOStaticStatus().open).ID;
      SubStatusID = this.initialData.CodeTypeData.WorkTicketSubStatus.find(x => x.Code.toLowerCase() == Constants.WOStaticStatus().unassigned).ID;
      toStatus = Constants.WOStaticStatus().unassigned;
      data.WorkTicketStatusAction = Constants.WOStaticStatus().Continue;
      data.Status = { ID: StatusID };
      data.SubStatus = { ID: SubStatusID };
    }
    let subscription = this.httpService.ChangeStatus(data).subscribe(
      response => {
        this.showspinner.hideLoader(this.viewContainerRef, this.tabCounter);
        if (this.confirmActionOkBtn == Constants.WOStaticStatus().SameTechnician && this.fromStatus == Constants.WOStaticStatus().open && this.fromSubStatus == Constants.WOStaticStatus().dispatched) {
          this.toastr.success(Constants.DefaultWorkOrderMessages.WorkOrderRecalledMessage, "Success!");
        } else if (this.confirmActionOkBtn == Constants.WOStaticStatus().RemoveTechnician && this.fromStatus == Constants.WOStaticStatus().open && this.fromSubStatus == Constants.WOStaticStatus().dispatched) {
          this.toastr.success(Constants.DefaultWorkOrderMessages.WorkOrderRecalledandUnAssignedMessage, "Success!");
        } else if (this.confirmActionOkBtn == Constants.WOStaticStatus().SameTechnician && this.fromStatus == Constants.WOStaticStatus().actionrequired && this.fromSubStatus == Constants.WOStaticStatus().rescheduled) {
          this.toastr.success(Constants.DefaultWorkOrderMessages.WorkOrderOpenMessage, "Success!");
        } else if (this.confirmActionOkBtn == Constants.WOStaticStatus().RemoveTechnician && this.fromStatus == Constants.WOStaticStatus().actionrequired && this.fromSubStatus == Constants.WOStaticStatus().rescheduled) {
          this.toastr.success(Constants.DefaultWorkOrderMessages.WorkOrderOpenandTechnicianMessage, "Success!");
        } else {
          let WorkOrderMessage: string =
            toStatus == Constants.WOStaticStatus().unassigned
              ? Constants.DefaultWorkOrderMessages.WorkOrderUnAssignedMessage
              : toStatus == Constants.WOStaticStatus().assigned
                ? Constants.DefaultWorkOrderMessages.WorkOrderAssignedMessage
                : toStatus == Constants.WOStaticStatus().rescheduled
                  ? Constants.DefaultWorkOrderMessages.WorkOrderResheduledMessage
                  : toStatus == Constants.WOStaticStatus().dispatched
                    ? Constants.DefaultWorkOrderMessages.WorkOrderDispatchedMessage
                    : toStatus == Constants.WOStaticStatus().void
                      ? Constants.DefaultWorkOrderMessages.WorkOrderVoidedMessage
                      : toStatus == Constants.WOStaticStatus().cancelled
                        ? Constants.DefaultWorkOrderMessages.WorkOrderCancelledMessage
                        : toStatus == Constants.WOStaticStatus().completed
                          ? Constants.DefaultWorkOrderMessages.WorkOrderCompletedMessage
                          : "";
          this.toastr.success(WorkOrderMessage, "Success!");
        }
        this.dataSharing.WOSChangeEvent({ destination: WOSChangeEventDestination.WOLanding, response: response });

        if (toStatus == Constants.WOStaticStatus().completed) {
          this.tabOpen.DestroyTab(this.tabCounter);

          this.tabOpen.OpenTab({
            tabId: Tabs.FsLiteWorkOrderList,
            params: {},
            tabTitle: "Work Orders"
          });
        }

        this.Details = response;
        this.confirmationBox = false;
        this.cancelReasonPopup = false;
        this.voidTicketPopup = false;
        this.confirmMessage = "";
        this.isError = false;
        this.confirmActionCancelBtn = "";
        if (data.WorkTicketStatusAction == Constants.WOStaticStatus().Unassign) {
          this.GetWorkOrderDetail();
        } else {
          this.GetStatusList();
        }
      },
      error => {
        this.showspinner.hideLoader(this.viewContainerRef, this.tabCounter);
        this.confirmationBox = false;
        this.confirmMessage = "";
        this.isError = false;
        this.confirmActionCancelBtn = "";
        if (!CommonMethods.CheckNullOrUndefined(error.error))
          this.toastr.showMultiLineError(error.error.Message, "Error");
      }
    );
    this.subscriptions.push(subscription);
  }
  private GetProductDefImage(row: any) {
    if (row.ImagePath == null || row.ImagePath == undefined || row.ImagePath == "") {
      if (row.Type != null && row.Type != undefined) {
        if (row.Type.toLocaleLowerCase() == "material") {
          return this.defaultMaterialImage;
        } else if (row.Type.toLocaleLowerCase() == "service") {
          return this.defaultServiceImage;
        } else {
          return this.defaultLaborImage;
        }
      } else row.ImagePath;
    } else return row.ImagePath;
  }
  private GetStatusList() {
    let StatusList = [];
    const technician = !FsUtil.checkNullOrUndefined([this.primaryTech])? this.primaryTech.User : null;
    if (this.Details.Status.Code.toLowerCase() == Constants.WOStaticStatus().open && this.Details.SubStatus.Code.toLowerCase() == Constants.WOStaticStatus().unassigned) {
      StatusList.push({ menu: Constants.WOStaticStatus().CompleteWorkOrder, submenu: [] });
      StatusList.push({ menu: Constants.WOStaticStatus().CancelWorkOrder, submenu: [] });
      StatusList.push({ menu: Constants.WOStaticStatus().VoidWorkOrder, submenu: [] });
    } else if (this.Details.Status.Code.toLowerCase() == Constants.WOStaticStatus().open && this.Details.SubStatus.Code.toLowerCase() == Constants.WOStaticStatus().assigned) {
      StatusList.push({ menu: Constants.WOStaticStatus().DispatchWorkOrder, submenu: [] });
      StatusList.push({ menu: Constants.WOStaticStatus().CompleteWorkOrder, submenu: [] });
      StatusList.push({ menu: Constants.WOStaticStatus().CancelWorkOrder, submenu: [] });
      StatusList.push({ menu: Constants.WOStaticStatus().VoidWorkOrder, submenu: [] });
    } else if (this.Details.Status.Code.toLowerCase() == Constants.WOStaticStatus().open && this.Details.SubStatus.Code.toLowerCase() == Constants.WOStaticStatus().dispatched) {
      if (technician)
        StatusList.push({ menu: Constants.WOStaticStatus().UndoDispatching, submenu: [Constants.WOStaticStatus().SameTechnician, Constants.WOStaticStatus().RemoveTechnician] });
      StatusList.push({ menu: Constants.WOStaticStatus().CompleteWorkOrder, submenu: [] });
      StatusList.push({ menu: Constants.WOStaticStatus().CancelWorkOrder, submenu: [] });
      StatusList.push({ menu: Constants.WOStaticStatus().VoidWorkOrder, submenu: [] });
    } else if (this.Details.Status.Code.toLowerCase() == Constants.WOStaticStatus().completed && this.Details.SubStatus.Code.toLowerCase() == Constants.WOStaticStatus().readyforreview) {
      StatusList.push({ menu: Constants.WOStaticStatus().RescheduleWorkOrder, submenu: [] });
      StatusList.push({ menu: Constants.WOStaticStatus().CancelWorkOrder, submenu: [] });
      StatusList.push({ menu: Constants.WOStaticStatus().VoidWorkOrder, submenu: [] });
    } else if (this.Details.Status.Code.toLowerCase() == Constants.WOStaticStatus().actionrequired && this.Details.SubStatus.Code.toLowerCase() == Constants.WOStaticStatus().rescheduled) {
      if (technician) {
        StatusList.push({ menu: Constants.WOStaticStatus().ContinuewithWorkOrder, submenu: [Constants.WOStaticStatus().SameTechnician, Constants.WOStaticStatus().RemoveTechnician] });
      } else {
        StatusList.push({ menu: Constants.WOStaticStatus().ContinuewithWorkOrder, submenu: [] });
      }
      StatusList.push({ menu: Constants.WOStaticStatus().CompleteWorkOrder, submenu: [] });
      StatusList.push({ menu: Constants.WOStaticStatus().CancelWorkOrder, submenu: [] });
      StatusList.push({ menu: Constants.WOStaticStatus().VoidWorkOrder, submenu: [] });
    } else if (this.Details.Status.Code.toLowerCase() == Constants.WOStaticStatus().actionrequired && this.Details.SubStatus.Code.toLowerCase() == Constants.WOStaticStatus().partsneeded) {
      if (technician) {
        StatusList.push({
          menu: Constants.WOStaticStatus().ContinuewithWorkOrder,
          submenu: [Constants.WOStaticStatus().SameTechnician, Constants.WOStaticStatus().RemoveTechnician]
        });
      } else {
        StatusList.push({
          menu: Constants.WOStaticStatus().ContinuewithWorkOrder,
          submenu: []
        });
      }
      StatusList.push({ menu: Constants.WOStaticStatus().CompleteWorkOrder, submenu: [] });
      StatusList.push({ menu: Constants.WOStaticStatus().CancelWorkOrder, submenu: [] });
      StatusList.push({ menu: Constants.WOStaticStatus().VoidWorkOrder, submenu: [] });
    } else {
      this.EditDisabled = this.commonMethods.IsWorkOrderEditDisabled(this.Details);
    }

    this.StatusList = StatusList;
    setTimeout(() => {
      var button = $(".dropdown-submenu button.test");
      button.unbind("click");
      $(".dropdown-submenu button.test").click(function (e) {
        $(this)
          .next("ul")
          .toggle();
        e.stopPropagation();
        e.preventDefault();
      });

      $('[data-toggle="dropdown"]').click(function () {
        $(this)
          .siblings(".dropdown-menu")
          .find(".dropdown-menu")
          .hide();
      });
    }, 100);
  }
  private GetWorkOrderDocumentsAndImages(workOrderAttachments: any) {
    if (workOrderAttachments != null) {
      this.attachments.data = workOrderAttachments.map(x => {
        return {
          FilePath: x.FilePath,
          Description: x.Description,
          FileName: x.FileName,
          IsImage: this.CheckIsImage(x),
          ID: x.ID,
          IsDirty: x.IsDirty,
          UploadedDate: x.CreateDate,
          UploadedBy: x.CreatedByUser != undefined && x.CreatedByUser != null ? x.CreatedByUser["FirstName"] + " " + x.CreatedByUser["LastName"] : ""
        }
      });
      this.attachments.total = this.attachments.data.length;
    }
  }
  private CheckIsImage(dataItem) {
    if (dataItem != null) {
      let fileName = dataItem.FileName;
      if (fileName != "") {
        let exts = ['.jpg', '.jpeg', '.gif', '.png', '.bmp'];
        return this.commonMethods.ValidExtension(fileName, exts);
      }
      else
        return false;
    }
    else
      return false;
  }
  // #endregion

  // #region  Public Events
  public tabContentClick() {
    // close window of current tab
    this.closeEquipmentLink();
  }
  public showEquipmentLinks(event, itemData) {
    event.stopPropagation();
    this.commonMethods.setKendoWindowPosition(event, this.EquipmentDialogueData);
    this.closeEquipmentLink();
    this.EquipmentDialogueData.Description = itemData.Description;
    this.EquipmentDialogueData.WorkTicketPriceBookItemEquipments = itemData.WorkTicketPriceBookItemEquipments;
    this.isEquipmentLinkOpened = true;
  }
  public closeEquipmentLink() {
    this.isEquipmentLinkOpened = false;
  }
  public RefreshTab(instantSpinnerTime: number = Constants.defaultSpinnertimeout)
  {
    this.InitializeForm(instantSpinnerTime);
  }
  public Toggle__collapse(trg, event) {
    if (event != null) {
      if ($(event.target).hasClass("newAttachment")) {
        return;
      }
    }
    var parent = $(trg);
    parent.toggleClass("hidden");
    parent.find(".collapse__box__body").slideToggle();
  }
  public GetAPBItems() {
    if (this.Details != null)
      this.approvedPBItems = {
        data: this.Details.WorkTicketPriceBookItems.filter(
          x => x.Status.Code.toLowerCase() == Constants.WOStaticStatus().approved
        ),
        total: this.Details.WorkTicketPriceBookItems.length
      };
    else this.approvedPBItems = { data: [], total: 0 };
  }
  public EditWorkOrder() {
    this.tabOpen.ReplaceTab({
      CurrentTabIndex: this.tabCounter,
      newTabInfo: {
        tabId: Tabs.FsLiteWorkOrderEdit,
        params: {
          ID: this.Details.ID,
          jobsiteId: this.Details.JobSite.ID,
          customerId: this.Details.Customer.ID,
          activeSubTabIndex: this.subTabs.filter(x => x.Selected == true)[0].Name == "Estimates" ? 0 : this.subTabs.filter(x => x.Selected==true)[0].Index
        },
        tabTitle: this.Details.WorkTicketNo
      }
    });
  }
  public ConfirmAction(val) {
    if (val) {
      this.ChangeStatusApi();
    } else {
      this.confirmationBox = false;
      this.confirmMessage = "";
      this.isError = false;
      this.confirmActionCancelBtn = "";
    }
  }
  public CancelOrder() {
    if (this.cancelationFormGroup.valid) {
      this.confirmActionOkBtn = Constants.WOStaticStatus().CancelWorkOrder;
      this.ChangeStatusApi();
    } else {
      this.commonMethods.markFormGroupTouched(this.cancelationFormGroup);
    }
  }
  public VoidOrder() {
    if (this.voidFormGroup.valid) {
      this.confirmActionOkBtn = Constants.WOStaticStatus().VoidWorkOrder;
      this.ChangeStatusApi();
    } else {
      this.commonMethods.markFormGroupTouched(this.voidFormGroup);
    }
  }
  public CloseCancelReasonPopup() {
    this.cancelReasonPopup = false;
  }
  public CloseVoidReasonPopup() {
    this.voidTicketPopup = false;
  }
  public ChangeStatus(toStatus) {
    if (toStatus == Constants.WOStaticStatus().CompleteWorkOrder) {
      if (
        this.Details.WorkTicketPriceBookItems.filter(
          x => x.Status.Code.toLowerCase() == Constants.WOStaticStatus().approved && x.WorkStatus == null
        ).length > 0
      ) {
        this.confirmationBox = true;
        this.confirmMessage =
          "All APPROVED line items must have a Work Status.";
        this.isError = true;
        this.confirmActionCancelBtn = "Ok";
        return;
      }
      if (
        this.Details.WorkTicketPayment == null ||
        ((this.Details.WorkTicketPayment.CustomerSignImg == null ||
          this.Details.WorkTicketPayment.CustomerSignImg == "") &&
          (this.Details.WorkTicketPayment.TechnicianSignImg == null ||
            this.Details.WorkTicketPayment.CustomerSignImg == ""))
      ) {
        this.confirmMessage = "Technician and Customer Signatures are missing.";
      } else if (
        this.Details.WorkTicketPayment.CustomerSignImg == null ||
        this.Details.WorkTicketPayment.CustomerSignImg == ""
      ) {
        this.confirmMessage = "Customer Signature is missing.";
      } else if (
        this.Details.WorkTicketPayment.TechnicianSignImg == null ||
        this.Details.WorkTicketPayment.TechnicianSignImg == ""
      ) {
        this.confirmMessage = "Technician Signature is missing.";
      }
      if (this.BalanceOwed > 0) {
        this.confirmMessage =
          this.confirmMessage +
          " <br>There is still a Balance Due on this Work Order.";
      }
      this.isError = false;
      this.confirmationBox = true;
      this.confirmActionOkBtn = "Complete with Warning";
      this.confirmActionCancelBtn = "Ok";
      if (this.confirmMessage != "") {
        return;
      } else {
        this.ChangeStatusApi();
      }
    } else if (toStatus == Constants.WOStaticStatus().CancelWorkOrder) {
      if (
        this.Details.WorkTicketPriceBookItems.filter(
          x =>  (x.Status.Code.toLowerCase() == Constants.WOStaticStatus().approved && x.Price !=0 )
        ).length > 0
      ) {
        //dollar value validation
        this.confirmationBox = true;
        this.confirmMessage =
          "Work Order has a dollar value; Cancelling is not allowed";
        this.isError = true;
        this.confirmActionCancelBtn = "Ok";
        return;
      } else {
        this.IntializeCancelationFrom();
        this.cancelReasonPopup = true;
      }
    } else if (toStatus == Constants.WOStaticStatus().VoidWorkOrder) {
      if (
        this.Details.WorkTicketPriceBookItems.filter(
          x => (x.Status.Code.toLowerCase() == Constants.WOStaticStatus().approved && x.Price !=0 )
        ).length > 0
      ) {
        //dollar value validation
        this.confirmationBox = true;
        this.confirmMessage =
          "Work Order has a dollar value; Voiding is not allowed";
        this.isError = true;
        this.confirmActionCancelBtn = "Ok";
        return;
      } else {
        this.IntializeVoidFrom();
        this.voidTicketPopup = true;
      }
    } else if (toStatus == Constants.WOStaticStatus().DispatchWorkOrder) {
      this.confirmActionOkBtn = Constants.WOStaticStatus().DispatchWorkOrder;
      this.ChangeStatusApi();
    } else if (toStatus == Constants.WOStaticStatus().RemoveTechnician) {
      this.confirmActionOkBtn = Constants.WOStaticStatus().RemoveTechnician;
      this.ChangeStatusApi();
    } else if (toStatus == Constants.WOStaticStatus().ContinuewithWorkOrder) {
      this.confirmActionOkBtn = Constants.WOStaticStatus().ContinuewithWorkOrder;
      this.ChangeStatusApi();
    } else if (toStatus == Constants.WOStaticStatus().SameTechnician) {
      this.confirmActionOkBtn = Constants.WOStaticStatus().SameTechnician;
      this.ChangeStatusApi();
    } else if (toStatus == Constants.WOStaticStatus().RescheduleWorkOrder) {
      this.confirmActionOkBtn = Constants.WOStaticStatus().RescheduleWorkOrder;
      this.ChangeStatusApi();
    }
  }
  public Print(printtype: string) {
    this.toastr.clear();
    this.showspinner.showloader(this.viewContainerRef, this.tabCounter);
    let subscription = this.httpService.Print(this.inputParams.ID, printtype).subscribe(response => {
      this.printService.PrintURL(this.commonMethods.GetDocumentPrintURL(response));
      this.showspinner.hideLoader(this.viewContainerRef, this.tabCounter);
    },
      error => {
        this.showspinner.hideLoader(this.viewContainerRef, this.tabCounter);
        this.toastr.showMultiLineError(error.error.Message, "Error");
      }
    );
    this.subscriptions.push(subscription);
  }
  public GetDayOfWeek(date) {
    return Constants.GetDayOfWeek(date);
  }
  public GetPhoneType(typeobject : any) : string
  {
    let result = this.commonMethods.getCompany(); 
    if(!CommonMethods.CheckNullOrUndefined(result) && !CommonMethods.CheckNullOrUndefined(result.CodeTypeData) &&
      !CommonMethods.CheckNullOrUndefined(result.CodeTypeData.ContactPhoneType) && (result.CodeTypeData.ContactPhoneType.length > 0))
      {
        let phonetypeName = result.CodeTypeData.ContactPhoneType.filter(x=> x.ID == typeobject.ID);
        if(!CommonMethods.CheckNullOrUndefined(phonetypeName))
          return phonetypeName[0]["Name"];
        else
          return "";
      }
      else
        return "";
  }

  public DispatchHelper(data: { dataItem: any, IsDispatch: boolean }) {
    let dataItem = data.dataItem;
    let IsDispatch = data.IsDispatch;
    this.showspinner.showloader(this.viewContainerRef, this.tabCounter);
    let submittedModel = this.commonMethods.GetAppointmentModel(dataItem, IsDispatch, this.initialData);
    let subscription = this.helperService.Put_Dispatch_Appointment(submittedModel).subscribe(
      (response) => {
        this.showspinner.hideLoader(this.viewContainerRef, this.tabCounter);
        if (IsDispatch)
          this.toastr.success(Constants.DefaultWorkOrderMessages.HelperDispatchedMessage, "Success");
        else
          this.toastr.success(Constants.DefaultWorkOrderMessages.HelperUndoDispatchedMessage, "Success");
        this.GetWorkOrderDetail();
      }, error => {
        this.showspinner.hideLoader(this.viewContainerRef, this.tabCounter);
        if (!CommonMethods.CheckNullOrUndefined(error.error))
          this.toastr.showMultiLineError(error.error.Message, "Error");
      })
    this.subscriptions.push(subscription);
  }
  /** used for attachment slider */
  ViewAttachmentSlide(idx: number) {
    this.slideIndex = idx;
    this.showAttachmentSlider = true;
  }

  /** used for attachment slider */
  CloseAttachmentSlider() {
    this.showAttachmentSlider = false;
  }
  viewAgreement(val) {
    this.tabOpen.OpenTab(TabParams.ViewServiceAgreement({ ID: val.ID, ServiceAgreementNumber: val.AgreementID, JobSite: { ID: this.Details.JobSite.ID } }, true));
  }

  createNewEstimate() {
    this.tabOpen.OpenTab(TabParams.NewEstimate({Customer:this.Details.Customer, JobSite: this.Details.JobSite, OriginWorkTicket: {ID: this.Details.ID}  }));
  }
  // #endregion
}
